var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"spacer h5"}),_c('h1',{staticClass:"colorful-title"},[_vm._v("Page Not Found")]),_c('div',{staticClass:"spacer h5"}),_c('p',{staticClass:"hint"},[_vm._v("Error Code 404")]),_c('div',{staticClass:"spacer h1"}),_c('p',[_vm._v("Oops! Looks like this page doesn't exist.")])])
}]

export { render, staticRenderFns }